import { isContentfulString, isUndefined } from '@philips-internal/oswald-ui-utils';
function sessionStorageError(message) {
    return new Error(`[Session Storage Service]: ${message}`);
}
function checkKey(key) {
    if (!isContentfulString(key)) {
        throw sessionStorageError('Trying to set an item with an empty key.');
    }
}
function convertToJSON(value) {
    return JSON.stringify(value, null, 0);
}
function convertFromJSON(value) {
    if (value === null) {
        throw sessionStorageError('Trying to convert empty value to JSON.');
    }
    return JSON.parse(value);
}
function createSessionStorageService() {
    const clear = () => {
        window.sessionStorage.clear();
    };
    const getItem = (key) => {
        checkKey(key);
        try {
            const item = window.sessionStorage.getItem(key);
            return convertFromJSON(item);
        }
        catch {
            return null;
        }
    };
    const removeItem = (key) => {
        checkKey(key);
        window.sessionStorage.removeItem(key);
    };
    const setItem = (key, value) => {
        checkKey(key);
        if (isUndefined(value)) {
            throw sessionStorageError('Trying to set an undefined item.');
        }
        const stringified = convertToJSON(value);
        window.sessionStorage.setItem(key, stringified);
    };
    return {
        clear,
        getItem,
        removeItem,
        setItem,
    };
}
const SessionStorageService = createSessionStorageService();
export { SessionStorageService, };
//# sourceMappingURL=session-storage-service.js.map